let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("74YvS")).then(() => parcelRequire('aAqp7'));